import { useContext } from "react"
import { ArrowTopRightOnSquareIcon } from "@heroicons/react/24/outline"
import { Panel } from "~/components/CommandMenu/Panel"
import { MultiContext } from "~/contexts/MultiContext"

export function Source() {
  const { data } = useContext(MultiContext)
  const onClick = ({ uuid }) => {
    const videoId = data.find((d) => d.uuid === uuid).videoId
    window.open(`https://www.youtube.com/watch?v=${videoId}`, "_blank").focus()
  }

  return (
    <Panel>
      <Panel.Heading>
        <Panel.HeadingDescription>
          Open the source video in a new browser tab
        </Panel.HeadingDescription>
      </Panel.Heading>
      <Panel.Layout Icon={ArrowTopRightOnSquareIcon} onClick={onClick} />{" "}
    </Panel>
  )
}
